import { render, staticRenderFns } from "./VesselParticular.vue?vue&type=template&id=9ec680ce&scoped=true&"
import script from "./VesselParticular.vue?vue&type=script&lang=js&"
export * from "./VesselParticular.vue?vue&type=script&lang=js&"
import style0 from "./VesselParticular.vue?vue&type=style&index=0&id=9ec680ce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ec680ce",
  null
  
)

export default component.exports